import { render, staticRenderFns } from "./media-selector.vue?vue&type=template&id=79a18e8e&scoped=true&"
import script from "./media-selector.vue?vue&type=script&lang=js&"
export * from "./media-selector.vue?vue&type=script&lang=js&"
import style0 from "./media-selector.vue?vue&type=style&index=0&id=79a18e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a18e8e",
  null
  
)

export default component.exports